import { render, staticRenderFns } from "./FolderAccessModal.vue?vue&type=template&id=9ba13e06&scoped=true"
import script from "./FolderAccessModal.vue?vue&type=script&lang=js"
export * from "./FolderAccessModal.vue?vue&type=script&lang=js"
import style0 from "./FolderAccessModal.vue?vue&type=style&index=0&id=9ba13e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba13e06",
  null
  
)

export default component.exports